/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("settlement.title")}
      </Typography>
      <hr />

      {/* Sobre / About */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement.analytics.sections.about.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement.analytics.sections.about.body")}
        </Box>
      </Typography>

      {/* Community Savings (%) */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement.analytics.sections.community_savings_perc.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement.analytics.sections.community_savings_perc.body")}
        </Box>
      </Typography>

      {/* Community Savings (€) */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement.analytics.sections.community_savings_abs.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement.analytics.sections.community_savings_abs.body")}
        </Box>
      </Typography>

      {/* Community Total Cost */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement.analytics.sections.community_total_balance.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement.analytics.sections.community_total_balance.body")}
        </Box>
      </Typography>

      {/* Savings chart */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement.analytics.sections.community_savings_chart.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement.analytics.sections.community_savings_chart.body")}
        </Box>
      </Typography>

      {/* Savings by member */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement.analytics.sections.savings_by_member.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement.analytics.sections.savings_by_member.body")}
        </Box>
      </Typography>

      {/* Buy/Sell info */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement.analytics.sections.buy_sell_info.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement.analytics.sections.buy_sell_info.body")}
        </Box>
      </Typography>

      {/* Economic balance */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement.analytics.sections.economic_balance.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement.analytics.sections.economic_balance.body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
